var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"dot dot1"}),_c('div',{staticClass:"dot dot2"}),_c('div',{staticClass:"dot dot3"}),_c('div',{staticClass:"dot dot4"}),_c('div',{staticClass:"dot dot5"}),_c('div',{staticClass:"dot dot6"}),_c('div',{staticClass:"dot dot7"})])])
}]

export { render, staticRenderFns }